import React from 'react'
import styled from "styled-components"

const Style = styled.div`
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
  width: ${props => props.width};
  max-width: ${props => props.maxWidth};
  padding: ${props => props.padding};
`

const Container = ({children, backgroundColor, color = "#000", width = "100%", padding = "0", maxWidth = "auto"}) => {
    return <Style backgroundColor={backgroundColor} color={color} width={width} padding={padding} maxWidth={maxWidth}>
        {children}
    </Style>
}

export default Container
